import React, { Component } from 'react';
import './App.css';
import { Menu, Container } from 'semantic-ui-react';

import { Link, Route, Switch } from 'react-router-dom';
import PackageList from './lib/components/PackageList';
import PackageView from './lib/components/PackageView';
import DocHub from './lib/components/DocHub';

import UrlHelper from './lib/url-helper';

class App extends Component {
  render() {
    return (
        <div className="App">
            <Menu>
                <Menu.Item><Link to={UrlHelper.getPackageListUrl()}>Packages</Link></Menu.Item>
                <Menu.Item><Link to={UrlHelper.getPackageListUrl( '@r3pi/ed3n', 'version', 'latest' )}>Ed3n</Link></Menu.Item>
                <Menu.Item><Link to={UrlHelper.getPackageListUrl( '@r3pi/dg2', 'version', 'latest' )}>Digital Garage</Link></Menu.Item>
                <Menu.Item><Link to={UrlHelper.getPackageListUrl( '@r3pi', 'version', 'alpha' )}>Alpha</Link></Menu.Item>

                <Menu.Item position={'right'}><Link to={UrlHelper.getDocListUrl( '@r3pi', 'version', 'alpha' )}>Docs</Link></Menu.Item>
            </Menu>

            <Container textAlign={'left'} fluid={true}>
                <Switch>
                    <Route path="/packages" component={PackageList}/>
                    <Route path="/package/:packageName" component={PackageView}/>
                    <Route path="/docs" component={DocHub} />
                    <Route component={PackageList}/>
                </Switch>
            </Container>
        </div>
    );
  }
}

export default App;




// WEBPACK FOOTER //
// ./src/App.js